export const getReachEstimateStyles = (_, core) => ({
  reachEstimateControl: {
    width: 400,
  },

  estimateNote: {
    color: '#323130',
    fontSize: 12,
  },

  panel: {
    minHeight: 161,
    paddingTop: 8,
    position: 'relative',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    borderRadius: 2,
    backgroundColor: `${core && core.palette && core.palette.white}`,
  },

  panelBody: {
    padding: 10,
  },

  reachEstimateTitle: {
    fontSize: 18,
    marginBottom: 8,
  },

  impressionsCountMessage: {
    fontSize: 18,
  },

  impressionsCount: {
    fontWeight: 'bold',
  },

  meterContainer: {
    height: 37,
    margin: '10px 0 13px 0',
    position: 'relative',
    fontSize: 12,
    '& .specificMeter': {
      width: '10%',
      height: 12,
      backgroundColor: '#C4C4C4',
      position: 'absolute',
      top: 17,
    },
    '& .broadMeter': {
      width: '90%',
      height: 12,
      backgroundColor: '#C4C4C4',
      position: 'absolute',
      top: 17,
      marginLeft: '10%',
    },
  },

  specificMeter: {
    width: '10%',
    height: 12,
    backgroundColor: '#C4C4C4',
    position: 'absolute',
    top: 17,
  },

  broadMeter: {
    width: '90%',
    height: 12,
    backgroundColor: '#C4C4C4',
    position: 'absolute',
    top: 17,
    marginLeft: '10%',
  },

  audienceSpecificLabel: {
    position: 'absolute',
    top: 35,
    fontSize: 12,
  },

  audienceBroadLabel: {
    position: 'absolute',
    top: 35,
    fontSize: 12,
    right: 0,
  },

  arrow: {
    backgroundColor: '#107C10',
    top: 5,
    width: 16,
    height: 35,
    position: 'absolute',
    border: `4px solid ${core && core.palette && core.palette.white} !important`,
    zIndex: 1,
  },
});
